// ConfigurePage.js
import React, { useEffect, useContext } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AppContext } from '../AppContext';

function ConfigurePage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setCustomers } = useContext(AppContext);

  useEffect(() => {
    // Extract URL parameters (using lower-case keys)
    const accountName = searchParams.get('accountname') || '';
    const contactName = searchParams.get('contactname') || '';
    const partnerContact = searchParams.get('partnercontact') || '';
    const parentAccountName = searchParams.get('parentaccountname') || '';
    const dealOwner = searchParams.get('dealowner') || '';
    const dealId = searchParams.get('dealid') || '';
    const dealName = searchParams.get('dealname') || '';
    const url = searchParams.get('url') || '';
    const phone = searchParams.get('phone') || '';

    // Ensure that at least the accountName is provided.
    if (accountName) {
      const newCustomer = {
        id: Date.now().toString(), // Unique ID as string
        accountName,
        contactName,
        partnerContact,
        parentAccountName,
        dealOwner,
        dealId,
        dealName,
        url,
        phone,
        synced: false,
        serviceData: {},
      };

      // Get current customers from localStorage and update them
      let customers = [];
      const storedCustomers = localStorage.getItem('customers');
      if (storedCustomers) {
        customers = JSON.parse(storedCustomers);
      }
      // Avoid duplicate insertion based on dealId (if provided)
      if (!dealId || !customers.find(c => c.dealId === dealId)) {
        customers.push(newCustomer);
        localStorage.setItem('customers', JSON.stringify(customers));
        // Update AppContext so that other pages see the new customer
        setCustomers(customers);
      }

      // Optionally, save as the selected customer as well
      localStorage.setItem('selectedCustomer', JSON.stringify(newCustomer));

      // Instead of navigating to the service config page,
      // navigate to the customer list page.
      navigate('/customers');
    } else {
      // Fallback if no required parameters are provided
      navigate('/customers');
    }
  }, [searchParams, navigate, setCustomers]);

  return <div>Configuring Customer...</div>;
}

export default ConfigurePage;
